import { render, staticRenderFns } from "./AsiListTableLayout.vue?vue&type=template&id=dafa623a&scoped=true"
import script from "./AsiListTableLayout.vue?vue&type=script&lang=ts"
export * from "./AsiListTableLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafa623a",
  null
  
)

export default component.exports